
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gFEwPuGsfa7Bw75yQYxqHZnQrQhMpPmfEUanrpv9SpXEMeta } from "/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexxAbUciuke_45PQRys5W5k8LqF5NtRhPndPNzjk81rCmcYMeta } from "/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchBWosINc5nm_kh0vs6YCdFyCy7dZCZSFfZPsSMrHNPKoMeta } from "/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index1x5JnuAfuJxu4zxbtWU6ImurjNPaaoAWsKkn_45BsYcZcMeta } from "/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93im10sRNJ_45ljMaPAFRRrfdGM9lShEOaEr1i3rKHszsbwMeta } from "/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexXVonW0QI9hucvh7iGTxiJ5Io1iVhv7hXed8fnuABsPEMeta } from "/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93H20oO_0dnkBDXRVhDJ7gAsHzqf2iN9_QWoiZBHp2VtQMeta } from "/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexXo_vpUt4jRu8FEYtGcHCB_45nBoaU9AXi3V_45Y9ZZVNRmEMeta } from "/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93DbJw38hu1qPf4DHqes8CzBfRG5_45GyyK_F61Wqlbodl8Meta } from "/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexbTNJGmP6HTEdJ72bDz_szNqME5RUAkSnqqQHMEKWML4Meta } from "/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index1BJKNXTBSmmAQxMUEtqhAOV2pt_45YLiyGPouryNTXBoUMeta } from "/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexXVonW0QI9hucvh7iGTxiJ5Io1iVhv7hXed8fnuABsPEMeta || {},
    component: () => import("/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexXo_vpUt4jRu8FEYtGcHCB_45nBoaU9AXi3V_45Y9ZZVNRmEMeta || {},
    component: () => import("/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexbTNJGmP6HTEdJ72bDz_szNqME5RUAkSnqqQHMEKWML4Meta || {},
    component: () => import("/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index1BJKNXTBSmmAQxMUEtqhAOV2pt_45YLiyGPouryNTXBoUMeta || {},
    component: () => import("/codebuild/output/src2668486075/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]